import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { findJurisdiction, JurisdictionId } from '../types/jurisdiction';
import { IJurisdictionState } from '../store/jurisdiction/types';

const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(52, 211, 153, 0.08);
  border: 1px solid rgba(52, 211, 153, 0.2);
  border-radius: 20px;
  padding: 4px 10px 4px 8px;
  color: #34d399;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.01em;
  flex-shrink: 0;
`;

const ChipFlag = styled.span`
  font-size: 14px;
  line-height: 1;
  flex-shrink: 0;
`;

/**
 * Read-only tag showing the active jurisdiction (flag + name) from the store.
 * Shared across enviro-chat, my-enviro-ai and enviro-deep-research composers.
 */
const JurisdictionChip: React.FC = () => {
  const jurisdictionId = useSelector<{ jurisdiction: IJurisdictionState }, JurisdictionId>(
    (s) => s.jurisdiction.activeId
  );
  const activeJurisdiction = useMemo(() => findJurisdiction(jurisdictionId), [jurisdictionId]);

  return (
    <Chip>
      <ChipFlag aria-hidden>{activeJurisdiction.flag}</ChipFlag>
      {activeJurisdiction.name}
    </Chip>
  );
};

export default JurisdictionChip;
